export default function isMeasurement(service) {
  return service.Order_Type === "CO";
}
